import { IAccountsReceivable, IBenefit, IFeesAndPremiums, IFlexibleField, IFlexibleFieldSet, IGroupConfigurationData, IGroupNumber, INonStandard, IPlan, IStopLoss } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer, ITransformContext } from "./IJsonTransformer";

export class UpdateOptionSetItemLogicalNameTransformer extends BaseJsonTransformer {
    async transformGroupConfiguration(json: IGroupConfigurationData): Promise<void> {
        this.processFields(json.fields);
    }

    async transformAttributeSet(attributeSet: IFlexibleFieldSet, context: ITransformContext): Promise<boolean | void> {
        this.processFields(attributeSet.fields);
    }

    async transformNonStandard(nonStandard: INonStandard, context: ITransformContext): Promise<boolean | void> {
        this.processFields(nonStandard.fields);
    }

    async transformBenefit(benefit: IBenefit): Promise<boolean | void> {
        this.processFields(benefit.fields);
    }

    async transformAccountsReceivable(accountsReceivable: IAccountsReceivable): Promise<boolean | void> {
        this.processFields(accountsReceivable.fields);
    }

    async transformStopLoss(stopLoss: IStopLoss): Promise<boolean | void> {
        this.processFields(stopLoss.fields);
    }

    async transformFeesAndPremium(feesAndPremium: IFeesAndPremiums): Promise<boolean | void> {
        this.processFields(feesAndPremium.fields);
    }

    async transformPlan(plan: IPlan): Promise<boolean | void> {
        this.processFields(plan.fields);
    }

    async transformGroupNumber(groupNumber: IGroupNumber): Promise<boolean | void> {
        this.processFields(groupNumber.fields);
    }

    processFields(sourceFields: IFlexibleField[]): void {
        for (let field of sourceFields) {
            if (!field)
                return;

            if (!field.values || !field.values.length)
                return;

            for (let value of field.values) {
                if (!value)
                    return;

                if (!value.value)
                    return;

                if (value.value.type === "entity") {
                    if (value.value.entityType === "bcbs_optionsetitem")
                        value.value.entityType = "bcbs_config_optionsetitem";

                    if (value.value.entityType === "costshare")
                        value.value.entityType = "bcbs_copaycoinoption";


                    if (value.value.entityType === "bcbs_admin")
                        value.value.entityType = "bcbs_bccadmin";


                }

            }
        }
    }
}
